export const BREAKPOINT_XXSMALL = 0;
export const BREAKPOINT_XSMALL = 401;
export const BREAKPOINT_SMALL = 541;
export const BREAKPOINT_MEDIUM = 721;
export const BREAKPOINT_LARGE = 901;
export const BREAKPOINT_XLARGE = 1025;
